import { useState } from "react";
import { PersonIcon } from "../icons/AppIcons";
import "./profile-photo-editor.css";

export type EditableAvatarProps = {
  displayName: string;
  photoUrl: string | null;
  size: number;
  editable: boolean;
  onEdit: () => void;
};

export function EditableAvatar({ displayName, photoUrl, size, editable, onEdit }: EditableAvatarProps) {
  const [failed, setFailed] = useState(false);
  const content = photoUrl && !failed
    ? <img className="editable-avatar__image" src={photoUrl} alt={`${displayName}の写真`} onError={() => setFailed(true)} />
    : <span className="editable-avatar__fallback" aria-hidden="true"><PersonIcon size={Math.max(24, Math.round(size * 0.5))} /></span>;

  if (!editable) {
    return <span className="editable-avatar" style={{ width: size, height: size }}>{content}</span>;
  }

  return (
    <button type="button" className="editable-avatar" style={{ width: size, height: size }} aria-label="プロフィール写真を設定" onClick={onEdit}>
      {content}
      <span className="editable-avatar__edit-badge" aria-hidden="true">✎</span>
    </button>
  );
}
